// src/components/card-info-modal/CardInfoModal.styles.js
import styled from 'styled-components';

export const ModalContainer = styled.div`  
  height: 100%;
  width: 100%;
  max-width: 1080px;
  max-height: 720px;
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 16px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: #FFFFFF;
  font-size: 28px;
  cursor: pointer;
  padding: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const ModalBody = styled.div`
  padding: 0 24px 24px 24px;
  flex: 1;
  overflow-y: auto;
`;

export const SectionRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
`;

export const InfoLabelContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const CopyBtnContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  text-align: center;
  cursor: pointer;
  padding: 0px 12px;
`;

export const CopyConfirmation = styled.span`
  color: #4CAF50;
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  transition: opacity 0.2s ease;
`;

export const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: flex-start;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  min-width: 0;
`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 50%;
`;

export const DescriptionPreview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const EbayDescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
`;

export const EbayDescriptionHelpText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  font-weight: 400;
  margin: 0 0 12px 0;
  line-height: 1.5;
`;

export const EbayDescriptionText = styled.textarea`
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 400;
  padding: 12px;
  min-height: 360px;
  resize: vertical;
  font-family: inherit;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
  cursor: text;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.4);
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`;

